var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOpen = function SvgOpen(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M14.813 11.75h-.876a.44.44 0 0 0-.437.438v3.062H4.75V6.5h3.938a.437.437 0 0 0 .437-.437v-.875a.437.437 0 0 0-.437-.438H4.312A1.313 1.313 0 0 0 3 6.063v9.625A1.313 1.313 0 0 0 4.313 17h9.625a1.313 1.313 0 0 0 1.312-1.312v-3.5a.44.44 0 0 0-.437-.438M16.343 3h-3.5a.658.658 0 0 0-.464 1.121l.977.977L6.69 11.76a.656.656 0 0 0 0 .93l.62.619a.655.655 0 0 0 .93 0l6.661-6.664.977.976A.657.657 0 0 0 17 7.156v-3.5A.656.656 0 0 0 16.344 3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOpen);
export default ForwardRef;